import request from '../utils/request.util'

export default {
  getKindAndActions () {
    return request.get('/roles/kind-and-actions')
  },
  getList (params) {
    return request.get('/roles', { params })
  },
  getOne (id) {
    return request.get(`/roles/${id}`)
  },
  create (params) {
    return request.post('/roles', params)
  },
  update (params) {
    return request.put(`/roles/${params.id}`, params)
  }
}
